import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Globe, ArrowUpRight } from "lucide-react";
import { brand, navPaths } from "../mock/mock";
import { useLang } from "../i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const links = [
    { label: t.nav.home, to: navPaths.home },
    { label: t.nav.about, to: navPaths.about },
    { label: t.nav.innovation, to: navPaths.innovation },
    { label: t.nav.whatWeDo, to: navPaths.whatWeDo },
    { label: t.nav.recipes, to: navPaths.recipes },
    { label: t.nav.allf, to: navPaths.allf },
    { label: t.nav.contact, to: navPaths.contact },
  ];
  const projLink = {
    allf: { to: navPaths.allfRestaurant },
    risorice: { to: navPaths.risorice },
    hotel: { to: navPaths.hotel },
  };

  return (
    <footer className="relative bg-[#14110F] text-white overflow-hidden">
      <div className="tricolor-bar h-1 w-full" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-1.5 mb-5">
              <span className="inline-flex items-center bg-white rounded-xl px-2.5 py-1.5 shadow-sm">
                <img src="/logo-mc.png" alt="MichelChef" className="h-8 w-auto" />
              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider text-[#22B573] mb-4">{t.footer.naviga}</h4>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-white/70 hover:text-white text-sm transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider text-[#22B573] mb-4">{t.footer.progetti}</h4>
            <ul className="space-y-3">
              {t.footer.projects.map((p) => {
                const link = projLink[p.key] || {};
                const inner = (
                  <>
                    {p.label}
                    <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </>
                );
                return (
                  <li key={p.key}>
                    {link.external ? (
                      <a href={link.href} target="_blank" rel="noreferrer" className="group inline-flex items-center gap-1 text-white/70 hover:text-white text-sm transition-colors">
                        {inner}
                      </a>
                    ) : (
                      <Link to={link.to || "/"} className="group inline-flex items-center gap-1 text-white/70 hover:text-white text-sm transition-colors">
                        {inner}
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-sm uppercase tracking-wider text-[#22B573] mb-4">{t.footer.dove}</h4>
            <div className="space-y-4">
              {t.locations.slice(0, 2).map((loc) => (
                <div key={loc.type} className="flex gap-2.5">
                  <MapPin size={16} className="text-[#E85A4F] mt-0.5 shrink-0" />
                  <div className="text-white/60 text-sm leading-relaxed">
                    <span className="text-white/90 font-medium block">{loc.type}</span>
                    {loc.address}, {loc.city}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">© {new Date().getFullYear()} {brand.legalName} — {t.footer.rights}</p>
          <div className="flex items-center gap-5 text-white/50 text-sm">
            <span className="inline-flex items-center gap-1.5"><Globe size={14} /> {t.footer.italyWorld}</span>
            <span className="inline-flex items-center gap-1.5"><Mail size={14} /> info@michelchef.it</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
